import { globalCss, mediaQueryMap } from "@leagueplatform/genesis-core";

export const pageStyleOverrides = globalCss({
  "#more-options-heading": {
    color: "$onSurfaceTextPrimary",
  },
  'nav[aria-labelledby="more-options-heading"] .GDS-icon': {
    color: "$onSurfaceTextPrimary",
  },
  'nav[aria-labelledby="more-options-heading"] button p:not(:last-child)': {
    marginBlockEnd: 0,
  },
  ".GDS-modal-content > .GDS-vertical-stack-layout:has(> img) > div > .GDS-utility-text.GDS-utility-text":
    {
      fontWeight: "$subtitleOne",
    },
  [`@media ${mediaQueryMap.laptop}, ${mediaQueryMap.desktop}`]: {
    ".care-documents-page .GDS-tab-list > .GDS-tab": {
      flex: "0 0 auto",
    },
    /* QUEST-2600: 164px = 140px page-header band + 40px Figma gap − 16px SDK
       sidebar margin; the doubled class outweighs the SDK's own margin rule. */
    ".about-me-sidebar.about-me-sidebar": {
      marginTop: "164px",
    },
  },
});
